import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { CustomValidators } from 'ng2-validation';

import { AuthService } from '../../services/auth.service';
import { SweetAlertService } from './../../../shared/services/sweet-alert/sweet-alert.service';
import { OrgaoService } from 'src/app/dashboard/services/orgao.service';

import { User } from './../../models/user.model';
import { Orgao } from 'src/app/dashboard/models/orgao.model';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {
  cardTitle: string = 'Criar Conta de Acesso';

  user: User;
  orgaos$: Observable<Orgao[]>;

  // Form definitions.
  form: FormGroup;
  @ViewChild('nome') nomeFocus: ElementRef;
  @ViewChild('email') emailFocus: ElementRef;
  @ViewChild('password') passwordFocus: ElementRef;
  @ViewChild('passwordConfirmation') passwordConfirmationFocus: ElementRef;

  // Form submission control.
  submitted: boolean = false;
  showPassword: boolean = false;

  // Control of loading of the service.
  segmentDimmed: boolean = true;

  constructor(
    private title: Title,
    private fb: FormBuilder,
    private authService: AuthService,
    private orgaoService: OrgaoService,
    private sweetAlertService: SweetAlertService,
    private router: Router
  ) { }

  ngOnInit() {
    this.title.setTitle(`SIVEL Check | ${ this.cardTitle }`);
    this.createForm();

    this.orgaos$ = this.orgaoService.getAll();

    this.segmentDimmed = false;
  }

  onSubmit() {
    // Disable submit to avoid multiple requests.
    this.submitted = true;
    this.segmentDimmed = true;

    return this.authService.signUp(this.form.value)
      .then(user => {
        if (this.form.valid) {
          this.submitted = false;
          this.segmentDimmed = false;

          this.sweetAlertService.success({ message: 'Sua conta de acesso foi criada com sucesso. Você deve aguardar a liberação do seu acesso pelo administrador do sistema.' });

          // Go to '/' or to last visited url before system logout.
          this.router.navigate(['/sign-in']);
        }
      })
      .catch(error => {
        this.submitted = false;
        this.segmentDimmed = false;

        console.log(error);

        if (error.code === 'auth/email-already-in-use') {
          this.sweetAlertService.error({ message: this.authService.errorMessage(error.code) }).then(() => {
            this.emailFocus.nativeElement.focus();
            this.emailFocus.nativeElement.select();
          });
        } else {
          this.sweetAlertService.error({ message: this.authService.errorMessage(error.code) }).then(() => {
            this.emailFocus.nativeElement.focus();
            this.emailFocus.nativeElement.select();
          });
        }
      });
  }

  resetForm(fieldFocus?: HTMLElement) {
    this.form.reset();

    if (fieldFocus) {
      fieldFocus.focus();
    }
  }

  toggleShowPassword() {
    if (this.showPassword) {
      this.passwordFocus.nativeElement.type = 'password';
      this.passwordConfirmationFocus.nativeElement.type = 'password';
    } else {
      this.passwordFocus.nativeElement.type = 'text';
      this.passwordConfirmationFocus.nativeElement.type = 'text';
    }
    this.showPassword = !this.showPassword;
  }

  private createForm() {
    // Create separately password control to use it with CustomValidators.equalTo for check password confirmation.
    let password = new FormControl('', [
      Validators.compose([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(25),
        Validators.pattern('^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$')
      ])
    ]);

    this.form = this.fb.group({
      email: [null, Validators.compose([Validators.required, Validators.email])],
      nome: [null, [Validators.required]],
      conhecidoComo: [null, [Validators.required]],
      orgao: [null, [Validators.required]],
      password: password,
      passwordConfirmation: ['', Validators.compose([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(25),
        Validators.pattern('^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$'),
        CustomValidators.equalTo(password)
        // PasswordValidators.repeatCharacterRegexRule(3),
        // PasswordValidators.alphabeticalCharacterRule(1),
        // PasswordValidators.digitCharacterRule(1),
        // PasswordValidators.lowercaseCharacterRule(1),
        // PasswordValidators.uppercaseCharacterRule(1),
        // PasswordValidators.specialCharacterRule(1)
      ])]
    });
  }
}
